import CageWelfareFishSpeedContainer from './CageWelfareFishSpeedContainer';

export default function CageWelfareFishSpeedProviderContainer() {
    return <CageWelfareFishSpeedContainer />;
}
